import { render, staticRenderFns } from "./modalFilaAtendimento.vue?vue&type=template&id=75cdd0b3&"
import script from "./modalFilaAtendimento.vue?vue&type=script&lang=js&"
export * from "./modalFilaAtendimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports